<template>
<div class="kt-portlet__head-actions">
    <slot></slot>
</div>
</template>

<script>
export default {

}
</script>